import React from "react";
import "../../../styles/Menu.scss";
import { useNavigate } from "react-router-dom";

const Menu: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = (item: string) => {
    if (item === "Gottix") {
      window.open("https://gottix.gottit.io/", "_blank");
    } else if (item === "Marketplace") {
      navigate("/");
    }
  };

  return (
    <div className="menu-wrapper">
      <div className="menu-container">
        {["Marketplace", "Gottix"].map((item, index) => (
          <React.Fragment key={item}>
            <div
              className={`menu-item ${item === "Marketplace" ? "active" : ""}`}
              onClick={() => handleClick(item)}
            >
              {item}
            </div>
            {index === 0 && <div className="menu-divider" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Menu;
